import { ErrorHandler, NgModule } from '@angular/core';

import { FaroErrorHandler } from './faro-error.handler';
import { MonitoringService } from './monitoring.service';

@NgModule({
    providers: [{ provide: ErrorHandler, useClass: FaroErrorHandler }],
})
export class MonitoringModule {
    /** @ts-expect-error ensure the service is instantiated even if it is not used explicitly in our application */
    constructor(private monitoringService: MonitoringService) {}
}
